import { createContext } from "react";
import { SignInActionType, SignInStateType } from "useSignIn";

/** Context used by the useSignIn hook to specify the visibility of various sign-in dialogs.  */
export const SignInContext = createContext<{
  state: SignInStateType,
  dispatch: React.Dispatch<SignInActionType>,
}>({ state: null as unknown as SignInStateType, dispatch: () => { } })